Apt.fn.make('message', {
	/**
	 * Initialize module
	 *
	 * @param {Object} options
	 * @returns {Object}
	 */
	init(options) {
		const scope = this;
		const priv = scope.$private;
		const conf = Object.assign({
			el: '$message',
			path: 'message',
			context: {}
		}, options);
		const $el = $(conf.el);

		priv.conf = conf;
		priv.uid = LS.util.uid();

		if (! options.gate && conf.target) {
			const previous = LS.store.get(conf.target + '_messages', {})[conf.id];

			if (previous) {
				options.gate = {
					date: Math.round((Date.now() - previous.sent) / 60000),
					message: 'You sent a message {{ date|dayFormat }} ago. If you don\'t hear back soon, follow up with a call.',
					cta: 'Send follow up'
				}
			}
		}

		$el.html($.view.render('message.form', {
			button: options.button,
			fields: options.fields,
			gate: options.gate,
			placeholder: conf.placeholder,
			required: conf.required || options.gate
		}));

		conf.$form = $$('messageForm', $el);

		priv.bind($el, options.gate);

		priv.populate();

		$$('messageContent', $el).resize(priv.uid);

		return scope;
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		LS.util.reset(this.$private.uid, null, null, true);
	}
}, {
	/**
	 * Bind message events
	 *
	 * @param {$} $el
	 * @param {Boolean} [gate=false]
	 */
	bind($el, gate) {
		const scope = this;
		const conf = scope.conf;

		let path = conf.path;
		let confirm;

		if (gate) {
			const $gate = $$('messageGate');

			$gate.on('click', () => {
				$gate.hide();
			}, {
				namespace: scope.uid
			});
		}

		if (conf.target) {
			path = conf.target + 's/' + conf.id + '/message';
		}

		LS.api.bind(conf.$form, path, {
			namespace: scope.uid,
			flash: false,
			data: data => {
				data.uid = LS.user.uid();
				data.url = location.pathname;

				if (confirm) {
					data.confirm = true;
				}

				$.exec(conf.transform, {
					args: [data]
				});

				return data;
			},
			prompt: {
				content: {
					confirm: 'Send',
					deny: 'Edit message'
				},
				confirm: () => {
					confirm = true;

					conf.$form.trigger('submit');
				},
				deny: () => {
					$$('messageContent', $el).focus(true);
				}
			},
			success: (data, xhr, req) => {
				$el[0].innerHTML = conf.sent ?
					conf.sent(data) : $.view.render('message.sent', data);

				if (conf.target) {
					LS.analytics.track({
						action: 'submit',
						target: conf.target,
						id: conf.id,
						category: 'message',
						attributes: {
							id: Number(data.id)
						}
					}, conf.context);
				}

				if ($.screen.size() < 4) {
					LS.util.setScroll($el);
				}

				LS.store.set('user_contact', {
					name: req.data.name,
					email: req.data.email,
					phone: {
						formatted: req.data.phone
					}
				});

				if (conf.target) {
					const key = conf.target + '_messages';
					const messages = LS.store.get(key, {});

					messages[conf.id] = {
						sent: Date.now()
					};

					LS.store.set(key, messages);
				}
			},
			error: (xhr, opt, message) => {
				LS.util.warn(message);

				if (xhr.status && xhr.status !== 422) {
					LS.log.issue('MessageError', xhr.responseText, {
						owner_id: conf.id,
						status: xhr.status
					}, {
						data: conf.data
					});
				}
			}
		});
	},

	/**
	 * Populate form with user data
	 */
	populate() {
		const scope = this;

		$.observe('user', data => {
			if (! data.account) {
				scope.fill(LS.store.get('user_contact'));

				return;
			}

			scope.fill(data.account);

			$.unobserve('*', {
				namespace: scope.uid
			});
		}, {
			init: true,
			namespace: scope.uid
		});
	},

	/**
	 * Fill form with user data
	 *
	 * @param {Object} [data]
	 */
	fill(data) {
		if (! data) {
			return;
		}

		const el = this.conf.$form[0];
		const phone = $$('messagePhone', el)[0];

		$$('messageName', el)[0].value = data.name || (
			data.first_name + ' ' + data.last_name
		);

		$$('messageEmail', el)[0].value = data.email;

		if (! phone.value && data.phone) {
			phone.value = data.phone.formatted;
		}
	}
});